import { render } from "./ParametrosIndex.vue?vue&type=template&id=5c0fa714&scoped=true&ts=true"
import script from "./ParametrosIndex.vue?vue&type=script&lang=ts"
export * from "./ParametrosIndex.vue?vue&type=script&lang=ts"

import "./ParametrosIndex.vue?vue&type=style&index=0&id=5c0fa714&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c0fa714"]])

export default __exports__